/* Domi Skin: ingredient popovers.
   Tap toggles on touch; hover is CSS. Both are kept inside the viewport.

   Note on placement: a closed popover is hidden with visibility, not display,
   so it still occupies layout and still counts toward the page's scrollable
   width. If one sticks out past the right edge the whole page gains horizontal
   scroll, which on a phone reads as the page sliding sideways. So every popover
   is placed on load and on resize, not only when it is opened. */
(function () {
  var GUTTER = 12;

  function place(wrap) {
    var pop = wrap.querySelector('.domi-star__pop');
    var btn = wrap.querySelector('.domi-star__btn');
    if (!pop || !btn) return;

    pop.style.left = '0px';
    pop.style.right = 'auto';
    pop.style.setProperty('--arrow-x', '19px');

    var anchor = btn.getBoundingClientRect();
    var box = pop.getBoundingClientRect();
    var vw = document.documentElement.clientWidth;
    var shift = 0;

    if (box.right > vw - GUTTER) shift = vw - GUTTER - box.right;
    if (box.left + shift < GUTTER) shift = GUTTER - box.left;

    pop.style.left = Math.round(shift) + 'px';

    var arrow = anchor.left + Math.min(anchor.width / 2, 34) - (box.left + shift);
    arrow = Math.max(14, Math.min(arrow, pop.offsetWidth - 14));
    pop.style.setProperty('--arrow-x', Math.round(arrow) + 'px');
  }

  function placeAll() {
    document.querySelectorAll('.domi-star').forEach(place);
  }

  function closeAll(except) {
    document.querySelectorAll('.domi-star.is-open').forEach(function (el) {
      if (el !== except) {
        el.classList.remove('is-open');
        var b = el.querySelector('.domi-star__btn');
        if (b) b.setAttribute('aria-expanded', 'false');
      }
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.domi-star__btn') : null;
    if (!btn) { closeAll(null); return; }
    var wrap = btn.parentElement;
    closeAll(wrap);
    place(wrap);
    var open = wrap.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  document.addEventListener('mouseover', function (e) {
    var wrap = e.target.closest ? e.target.closest('.domi-star') : null;
    if (wrap) place(wrap);
  });

  document.addEventListener('focusin', function (e) {
    var wrap = e.target.closest ? e.target.closest('.domi-star') : null;
    if (wrap) place(wrap);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll(null);
  });

  var t;
  window.addEventListener('resize', function () {
    closeAll(null);
    clearTimeout(t);
    t = setTimeout(placeAll, 120);
  });

  window.addEventListener('orientationchange', function () {
    clearTimeout(t);
    t = setTimeout(placeAll, 200);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', placeAll);
  } else {
    placeAll();
  }

  /* Fonts and images settle after first paint and can move the chips, so
     place once more when everything has loaded. */
  window.addEventListener('load', placeAll);
})();
